import Project from "../components/Project.jsx";
import { ProjectLinks, ProjectLink } from "../components/ProjectLinks.jsx";
import Typography from "@mui/material/Typography";

export default function Main() {
  return (
    <Project
      title="NGHTTTP2"
      picture={
        <img
          alt="graph"
          className="project-img"
          src={require("../pictures/nghttp2.jpg.avif")}
          width={400}
        />
      }
      text={
        <Typography align="justify" sx={styles.text}>
          A simple HTTP/2 client using the Nghttp2 library with bindings in
          Python and Rust. The client supports basic HTTP/2 features such as
          multiplexing, header compression, and secure (HTTPS) connections. I
          also implemented a packet filter to simiulate network conditions such
          as latency and packet loss. This was commission for the Andyl.
        </Typography>
      }
      links={
        <ProjectLinks>
          <ProjectLink
            icon="github"
            link="https://github.com/brianiscoding/dylan"
          >
            Github
          </ProjectLink>
          <ProjectLink link="https://nghttp2.org">Nghttp2</ProjectLink>
          <ProjectLink link="https://www.andyl.com">Andyl</ProjectLink>
        </ProjectLinks>
      }
    />
  );
}

const styles = {
  text: {
    width: 0.9,
    fontSize: 20,
  },
};
